export default {
  appName: '的士达',                                                  //的士达
  title: '的士达',                                                    //的士达
  // api: 'https://server.disda.canary.korange.cn:18081/biz/customer',   //本地平台
  // api: "http://172.16.36.193:8081/ochs-prod-tbd-biz-customer",     //本地平台
  api: 'https://server.dishida.net/biz/customer',                     //线上平台
  mapKey: '293b5ca1a282c01374ea202cd795f4ab',                         //地图密钥
  mapVersion: '2.0',                                                  //地图版本
  // defaultPosition: [120.209741,30.246632],                         //杭州（线上）
  // defaultPosition: [120.080828, 30.290273],                        //杭州（测试）
  defaultPosition: [120.082474, 30.289251],                           //公司办公室
  // defaultPosition: [119.984901,30.244412],                         //公司办公室
  defaultMapZoom: 14,                                                 //杭州
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  versionCode: 1.002025071201,
  versionName: 'v' + '1.0.0-002025071201',
  versionUpdateMode: 'auto'                                              //auto（自动）、manual（手动）、signal（远程信号）
};
